import Vue from 'vue'
import './plugins/vuetify'
import VueFetch from './plugins/fetch'
import App from './components/App.vue'
import router from './router'
import i18n from './i18n/i18n'
import store from './store'
import VueCookie from "vue-cookie"
import 'babel-polyfill'
import "nprogress/nprogress"
import "nprogress/nprogress.css"
import "./global-components"

Vue.config.productionTip = false
Vue.prototype.$env = window.env;
Vue.use(VueFetch, { baseUrl: window.env.serwerURL })
Vue.use(VueCookie);

new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app')
